// VzmCheckbox.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import { FormControlLabel, Checkbox } from "@mui/material";
// import { styled } from "@mui/material/styles";


export default function VzmCheckbox({
    dict,
    value,
    onChange,
    onFocused,
    onMouseEnter,
    disabled,
    label,
    fontSize,
}) {
    const trueValue = dict.trueValue || true;
    const falseValue = dict.falseValue || false;
    const boolValue = value === trueValue;

    const controlLabel = label || dict.label;

    const onChangeValue = (e) => {
        const value = e.target.checked ? trueValue : falseValue;
        onChange(dict.id, value);
    };

    const sxValue
    = fontSize
    ? { '& .MuiFormControlLabel-label': {
        fontSize: fontSize,
    }}
    : undefined;

    return(
        <FormControlLabel
            control={
                <Checkbox
                    checked={boolValue || false}
                    onChange={onChangeValue}
                    disabled={disabled}
                    required={dict.required}
                />
            }
            label={controlLabel}
            onMouseEnter={()=>{if(onMouseEnter) onMouseEnter(dict)}}
            onFocus={()=>{if(onFocused) onFocused(dict)}}
            sx={sxValue}
        />
    );
}